// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SK+3d","__in":"styles___in__5Fn7U","logo":"styles_logo__7zBmK","menu":"styles_menu__pICVy","li":"styles_li__cKxiU","before":"styles_before__dBe7A"};